import store from '@carvana/purchase-store';
import * as Services from '../services';
import * as types from './actionTypes';

export const FetchVerifications = () =>
  store
    .dispatch({
      type: types.VERIFICATIONS_FETCH,
      async payload() {
        return Services.fetchVerifications();
      }
    })
    .catch(err => Promise.reject(err));

export const FetchOrderOptions = () =>
  store.dispatch({
    type: types.ORDER_OPTIONS_FETCH,
    payload: Services.fetchOrderOptions()
  });

export const FetchPaymentCollection = () =>
  store.dispatch({
    type: types.PAYMENT_COLLECTIONS_FETCH,
    async payload() {
      return Services.fetchPaymentCollection();
    }
  });
